const actions = {
  SET_STATE: 'apiKeys/SET_STATE',
  API_KEYS_LIST: 'apiKeys/API_KEYS_LIST',
  GET_APIKEY: 'apiKeys/GET_APIKEY',
  ADD_APIKEY: 'apiKeys/ADD_APIKEY',
  ENTER_APIKEY_TEXT: 'apiKeys/ENTER_APIKEY_TEXT',
  SEARCH_APIKEY: 'apiKeys/SEARCH_APIKEY',
  UPDATE_APIKEY: 'apiKeys/UPDATE_APIKEY',
  DELETE_APIKEY: 'apiKeys/DELETE_APIKEY',
}

export default actions
